import "./SevenUpDownPL.scss";
import React, { useEffect, useState } from 'react'

const SevenUpDownPL = ({roundMarkets}) => {
 let [winnerData, setWinnerData] = useState(null);

 const getWinner = () => {
   let winObj = {
     winners: ""
   };
   if (roundMarkets.length > 0) {
     roundMarkets.forEach((market) => {
       market.marketRunner.forEach((runner) => {
         if (runner.status === 'WINNER') {
           winObj[market.marketHeader] = runner.name;
         }
       });
     });
   }
   setWinnerData(winObj)
  }
  useEffect(() => {
    getWinner()
  }, [roundMarkets]);

  const cardSrc = (card) => {
    if (card) {
      return `https://stream.fawk.app/assets/smallCards/${card}.png`;
    } else {
      return "https://stream.fawk.app/assets/smallCards/BACK.png";
    }
  };

    return (
      <div className="seven-up-down-betting">
        <div className="seven-up-down-betting__games-item">
          <div className="seven-up-down-betting__games-item-cards">
            {roundMarkets && roundMarkets[0].indexCard.map( card =>
              <img key={card}
                   src={cardSrc(card)}
                   alt={card}
              />
            )}
          </div>
        </div>
        {winnerData && <div className="seven-up-down-betting__info-column">
          <div className="seven-up-down-betting__info-row">
            <div className="seven-up-down-betting__info-row-title">
              <span>Winner:</span>
            </div>
            <div className="seven-up-down-betting__info-row-results">
              <span>{winnerData['Match odds']  || 'No Winner'}</span>
            </div>
          </div>
          <div className="seven-up-down-betting__info-row">
            <div className="seven-up-down-betting__info-row-title">
              <span>Odd/Even: </span>
            </div>
            <div className="seven-up-down-betting__info-row-results">
            <span>
              {winnerData['Odd-Even']  || 'No Winner'}
            </span>
            </div>
          </div>
          <div className="seven-up-down-betting__info-row">
            <div className="seven-up-down-betting__info-row-title">
              <span>Color:</span>
            </div>
            <div className="seven-up-down-betting__info-row-results">
              <span>{winnerData['Colour'] || 'No Winner'}</span>
            </div>
          </div>
          <div className="seven-up-down-betting__info-row">
            <div className="seven-up-down-betting__info-row-title">
              <span>Card:</span>
            </div>
            <div className="seven-up-down-betting__info-row-results">
              <span>{roundMarkets[0].indexCard[0].slice(1, 2)}</span>
            </div>
          </div>
          <div className="seven-up-down-betting__info-row">
            <div className="seven-up-down-betting__info-row-title">
              <span>Suit: </span>
            </div>
            <div className="seven-up-down-betting__info-row-results">
              <span>{winnerData['Suit']  || 'No Winner'}</span>
            </div>
          </div>
        </div>}
      </div>
);
};

export default SevenUpDownPL;

